/**
 * Common styles and layout constants used throughout the project team components
 */
export const BASE_STYLE = {
    // Layout related
    SIDEBAR_WIDTH: 'w-1/6',
    CONTENT_WIDTH: 'w-5/6',
    DETAIL_CONTENT_WIDTH: 'w-4/6',

    // Margin related
    BOTTOM_MARGIN: 'mb-17',
    TOP_MARGIN: 'mt-10',

    // Spacing related
    GAP_STANDARD: 'gap-4',
    GAP_LARGE: 'gap-8',
    // Text styles
    TEXT_BASE:
        'text-5 leading-[1.3] tracking-[0.025rem] fonr-[400] text-[#141414]',
    TEXT_HEADING:
        'text-[4.375rem] leading-[1.1] font-normal tracking-[-0.0875rem] text-[#141414]',

    // Interaction related
    TRANSITION_STANDARD: 'transition-all duration-5000',
    TRANSITION_FAST: 'transition-all duration-3000',
    TRANSITION_SLOW: 'transition-all duration-7000',
    TRANSITION_SLOWER: 'transition-all duration-1000',

    // Animation related
    FADE_IN_FAST: 'animate-fadeIn opacity-0',
    FADE_IN_STANDARD: 'animate-fadeIn opacity-0 delay-100',
    FADE_IN_SLOW: 'animate-fadeIn opacity-0 delay-300',
    ANIMATION_FILL_MODE: 'animation-fill-forwards',

    // Button styles
    CAROUSEL_BUTTON: 'bg-gray-300 p-2',
    CAROUSEL_BUTTON_DISABLED: 'opacity-[0.05] cursor-not-allowed',

    // CSS for inline styles
    INLINE_STYLES: {
        FADE_IN_FAST: {
            opacity: 0,
            animation: 'fadeIn 1s forwards',
            animationDelay: '0.1s',
        },
        FADE_IN_STANDARD: {
            opacity: 0,
            animation: 'fadeIn 1s forwards',
            animationDelay: '0.5s',
        },
        FADE_IN_SLOW: {
            opacity: 0,
            animation: 'fadeIn 1s forwards',
            animationDelay: '0.9s',
        },
        FADE_IN_SLOWER: {
            opacity: 0,
            animation: 'fadeIn 1s forwards',
            animationDelay: '1.0s',
        },
    },
};
